





















































































































import { util, windowHelper } from '@tencent/ppd-base-libs';
import { biHT } from '@/business/bi';
import { i18n } from '@/i18n';
import { getFormattedDate } from '../../util/dateHelper';
import { getUsageText } from '../../business/display-coupon-record';
import { parseHK$Aria } from '@tencent/wphk-act-base-ui';
export default {
  props: {
    couponDetail: {
      type: Object,
    },
    isShowCond: {
      type: Boolean,
    },
    isShowPage2: {
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    i18n,
    getUsageText,
    getFormattedDate,
    parseHK$Aria,
    async onclicktandc() {
      (this as any).isShowPage2
        ? biHT('promotion.merchantcoupon.coupondetails.TNC_click')
        : biHT('promotion.merchantcoupon.tousecoupondetails.TNC_click');
      const { couponTandc } = (this as any).couponDetail;
      if (couponTandc) {
        windowHelper.redirect(couponTandc, 300);
      }
    },
  },
};
